module.exports = __webpack_public_path__ + "img/process6.a073e33a.png";